export enum ExternalJobDisplayPayIntrosEnum {
    LeaveBlank = 1,
    StartingAt = 2,
    UpTo = 3,
    Range = 4,
    BasedOnExperience = 5
}
